import { CognitoUser } from "amazon-cognito-identity-js";
import { userPool } from "../../utils/aws";
import toastMessage from "../../utils/toastMessage";

const otpVerification = (username, otp, callback=()=>{}) => {
    console.log(username, otp, " = otpVerification");
    var userData = {
        Username: username,
        Pool: userPool,
    };

    var cognitoUser = new CognitoUser(userData);
    cognitoUser.confirmRegistration(otp, true, function(err, result) {
        if (err) {
            console.log(err, " = confirmRegistration");
            callback(err.message);
        }
        else{
            console.log('otpVerification: call result: ' + result);
            callback(null, "Successfully Verified");
        }
    });
}


export default otpVerification;